import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import ScheduleGradeAircraftLineGroup from './ScheduleGradeAircraftLineGroup';
import ScheduleGradeAircraftLineDouble from './ScheduleGradeAircraftLineDouble';
import ScheduleGradeAircraftLineCrew from './ScheduleGradeAircraftLineCrew';
import ScheduleGradeAircraftLineDays from './ScheduleGradeAircraftLineDays';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeTrainingVacationLineAlternate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      toggled: 0,
      sgas: {},
    };

    this.locale = getLocale();

    //bind específico
    this.deleteCrew = this.deleteCrew.bind(this);
    this.toggleAllSelect = this.toggleAllSelect.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.sgas.staff !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        sgas: newProps.sgas,
        loaded: 1,
      });
    }
  }


  toggleAllSelect() {
    this.setState({
      toggled: 1,
    });
  }

  // Remove a aeronave da grade
  deleteCrew(event) {
    var confirm = window.confirm(this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.removerTripulante);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/remover/tripulacao/ferias/' + self.props.sgas.sgas_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
  <tr>

    <td className="text-center">
      <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
      <button className="btn btn-danger btn-xs" onClick={this.deleteCrew}><i className="fa fa-trash"></i></button>
    </td>
    <td className="text-center">{self.state.sgas.period}</td>
    <td className="text-center">{self.state.sgas.staff}</td>
    <td className="text-center">{self.state.sgas.inscription}</td>
    <td className="text-center">{self.state.sgas.role_alternate}</td>
    {Object.keys(self.props.schedule_days).map(function(k) {
      var day = self.props.schedule_days[k];
      if (typeof self.state.sgas.days !== 'undefined') {
        if (typeof self.state.sgas.days[day.day] !== 'undefined') {
          return(
            <ScheduleGradeAircraftLineDays schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} toggleAllSelect={self.toggleAllSelect} updated={self.props.updated} handleAlert={self.props.handleAlert} initials_colors={self.props.initials_colors} types_list={self.props.types_list} sgas_id={self.state.sgas.sgas_id} toggled={self.state.toggled} day={self.state.sgas.days[day.day]} />
          );
        } else {
          return(
            <td style={{background: 'blue'}}>&nbsp;</td>
          );
        }
        return('');
      }
    })}

  </tr>
    );
  }
}

export default ScheduleGradeTrainingVacationLineAlternate;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeTrainingVacationLineAlternate.js